import React, { memo } from 'react';
import { Dot, MarkerWrapper, MarkerContainer } from './styled';
import { Marker } from '../types';

export interface ItemsMapMarkerOverlayProps {
  marker: Marker;
  isActive: boolean;
  onMarkerClick: (value: Marker) => void;
}

export const ItemsMapMarker: React.FC<ItemsMapMarkerOverlayProps> = memo(
  ({ marker, isActive, onMarkerClick }) => {
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onMarkerClick(marker);
    };

    const isCluster = marker.type === 'ClusterMapMarker';

    return (
      <MarkerContainer
        onClick={handleClick}
        $isActive={isActive}
        data-cy={isCluster ? 'map-cluster-marker' : 'map-item-marker'}
        data-marker-id={marker.id}
        {...(isCluster && { 'data-marker-ids': marker.itemsIds?.join(',') })}
      >
        <Dot />
        <MarkerWrapper role="button">{marker.label}</MarkerWrapper>
      </MarkerContainer>
    );
  }
);

ItemsMapMarker.displayName = 'ItemsMapMarker';
